<template>
  <div>
    <v-simple-table class="facebook-responsible-table" height="800" fixed-header>
      <thead>
      <tr>
        <th>Master content ID</th>
        <th>Content ID</th>
        <th>Fanpage</th>
        <th>AD_ID</th>
      </tr>
      </thead>
      <tbody v-if="masterContentId && masterContentId.length > 0">
        <template v-for="(item) in masterContentId">
        <template v-for="(content, contentIndex) in item.contentId">
          <template v-for="(fanPage, fanPageIndex) in content.fanpageId">
            <template v-for="(adId, adIdIndex) in fanPage.adId">
              <tr v-if="contentIndex === 0 && fanPageIndex === 0 && adIdIndex === 0">
                <td :rowspan="item.count">{{item._id}}</td>
                <td :rowspan="content.count">{{content._id}}</td>
                <td :rowspan="fanPage.count">{{fanPage._id}}</td>
                <td class="adId-td" :rowspan="adId.count">
                  <div class="d-flex justify-space-between">
                    {{adId._id}}
                    <div class="hover-to-show">
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_update')" @click="handleShowPopup('edit', item._id, content._id, adId._id)">
                        mdi-pencil
                      </v-icon>
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_delete')" @click="handleDeleteCode(item._id, content._id, adId._id)">
                        mdi-delete
                      </v-icon>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-else-if="fanPageIndex === 0 && adIdIndex === 0">
                <td :rowspan="content.count">{{content._id}}</td>
                <td :rowspan="fanPage.count">{{fanPage._id}}</td>
                <td class="adId-td" :rowspan="adId.count">
                  <div class="d-flex justify-space-between">
                    {{adId._id}}
                    <div class="hover-to-show">
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_update')" @click="handleShowPopup('edit', item._id, content._id, adId._id)">
                        mdi-pencil
                      </v-icon>
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_delete')" @click="handleDeleteCode(item._id, content._id, adId._id)">
                        mdi-delete
                      </v-icon>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-else-if="adIdIndex === 0">
                <td :rowspan="fanPage.count">{{fanPage._id}}</td>
                <td class="adId-td" :rowspan="adId.count">
                  <div class="d-flex justify-space-between">
                    {{adId._id}}
                    <div class="hover-to-show">
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_update')" @click="handleShowPopup('edit', item._id, content._id, adId._id)">
                        mdi-pencil
                      </v-icon>
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_delete')" @click="handleDeleteCode(item._id, content._id, adId._id)">
                        mdi-delete
                      </v-icon>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-else>
                <td class="adId-td" :rowspan="adId.count">
                  <div class="d-flex justify-space-between">
                    {{adId._id}}
                    <div class="hover-to-show">
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_update')" @click="handleShowPopup('edit', item._id, content._id, adId._id)">
                        mdi-pencil
                      </v-icon>
                      <v-icon color="#898EFF" style="cursor: pointer" v-if="checkAuthorization('define-master-content_delete')" @click="handleDeleteCode(item._id, content._id, adId._id)">
                        mdi-delete
                      </v-icon>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </template>
        </template>
      </template>
      </tbody>
      <tbody v-else-if="!loading">
        <tr>
          <td colspan="4" style="border: none !important; color: red; padding-top: 40px" class="text-center">
            Không có dữ liệu
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <master-content-popup ref="popupContent" :mode="mode" :form-data="formData" :is-show="isShowPopup" @close="isShowPopup = false" @submit="handleSubmit"/>
  </div>
</template>

<script>
import MasterContentPopup from "@/pages/report-mkt/define-facebook-page-responsible/component/MasterContentPopup";
import ReportRepository from "@/repositories/ReportRepository";
export default {
  name: "FacebookResponsibleTable",
  components: {
    MasterContentPopup,
  },
  data() {
    return {
      loading: null,
      isShowPopup: false,
      masterContentId: [],
      formData: {},
      oldFormData: {},
      mode: 'create',
    }
  },
  created() {
    this.getListMasterContentId();
  },
  methods: {
    async handleDeleteCode(masterId, contentId, adId) {
      // if (fanpageId) {
      //   this.$swal({
      //     title: 'Mã đã có data, không thể xóa !',
      //     toast: true,
      //     showConfirmButton: false,
      //     position: 'top-end',
      //     timer: 3000,
      //     icon: 'error'
      //   })
      //   return
      // }
      this.$swal({
        text: 'Bạn chắc chắn muốn xóa bộ mã này ?',
        showCancelButton: true,
        cancelButtonText: 'Hủy',
        confirmButtonText: 'Xóa',
        confirmButtonColor: '#FF8057',
        cancelButtonColor: '#9A9A9A',
      }).then(async (res) => {
        if (res.value) {
          const response = await ReportRepository.deleteMktCode({
            masterId,
            contentId,
            adId
          })
          if (response.success) {
            this.$swal({
              text: 'Xóa bộ mã thành công',
              icon: 'success',
            })
            this.getListMasterContentId();
          } else {
            this.$swal({
              text: `Lỗi khi xóa bộ mã. ${response.message}`,
            })
          }
        }
      })
    },
    async handleSubmit(data) {
      if (this.mode === 'create') {
        const response = await ReportRepository.createMktCode(data);
        if (response.success) {
          this.isShowPopup = false;
          this.$swal({
            text: 'Tạo bộ mã thành công',
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            icon: 'success'
          })
          this.getListMasterContentId();
        } else {
          this.$swal({
            text: response.message,
          })
        }
      } else {
        let dataSent = {
          oldData: this.oldFormData,
          newData: data,
        }
        const response = await ReportRepository.updateMktCode(dataSent);
        if (response.success) {
          this.isShowPopup = false;
          this.$swal({
            text: 'Cập nhật dữ liệu thành công',
            showConfirmButton: false,
            timer: 2000,
            icon: 'success'
          })
          this.getListMasterContentId();
        } else {
          this.$swal({
            text: response.message,
          })
        }
      }

    },
    handleShowPopup(mode, masterContentId, contentId, adId) {
      if (mode === 'edit') {
        this.oldFormData = {
          masterId: masterContentId,
          contentId: contentId,
          adId,
        }
        this.mode = 'edit'
        this.formData = _.cloneDeep(this.oldFormData)
      }
      else {
        this.mode = 'create'
        this.formData = {}
      };
      this.isShowPopup = true;
      this.$refs.popupContent.resetValidate();
    },
    async getListMasterContentId(params) {
      this.loading = true;
      let loading = this.$loading.show();
      const paramsDefault = {
        page: 0,
        limit: 20,
        ...params
      }
      const result = await ReportRepository.getListMasterContentId(paramsDefault)
      if (result.success) {
        this.masterContentId = result.data.data;
      }
      loading.hide();
      this.loading = false;
    }
  }
}
</script>

<style scoped lang="scss">
.facebook-responsible-table {
  thead {
    th {
      background: #d4d5ff !important;
    }
    tr {
      th {
        background: #d4d5ff !important;
        color: #5D62D1 !important;
        border-right: 1px solid white;
        font-weight: bold;
        font-size: 14px;
        height: 60px !important;
      }
    }
  }
  tbody {
    tr {
      &:last-child {
        td {
          border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
        }
      }
      &:hover {
        td {
          background: white !important;
        }
      }
      td {
        //border: thin solid rgba(0, 0, 0, 0.12);
        border-right: thin solid rgba(0, 0, 0, 0.12);
        border-left: thin solid white;
        border-bottom: thin solid white;
        border-top: thin solid white;
      }
      .adId-td {
        .hover-to-show {
          visibility: hidden;
        }
        &:hover {
          .hover-to-show{
            visibility: visible;
          }
          border-color: #898EFF !important;
        }
      }
    }
  }
}
</style>